import React from 'react'
import { topReasons } from '../utils/hire'
import "./TopReasons.css"
function TopReasons() {
  return (
    <section className='top-reasons'>
       <div className='reason-content'>
       <p className='pricing-title-s '>Top Reasons</p>
       <h2 className='pricing-title-p'>Top Reasons to Hire a Dedicated Development Team from <span>Tech It Easy</span></h2>
       </div>
       <div className='reasons-container'>
        {topReasons.map((reason,index)=> {
            return <div key={index} className='reason-container'>
                <p>{reason}</p>
            </div>
        })}
       </div>
    </section>
  )
}

export default TopReasons